import React, { Component } from 'react';
import moment from 'moment-timezone';
import { map } from 'lodash';
import Loader from '../../../Common/Component/Loader';
import { errorHandle } from '../../../Common/errorHandle';
import IntialTable from './Common/ServiceToPerform/IntialTable';
// import InstallTable from './Common/ServiceToPerform/InstallTable';
import workOrderStatus from '../../../Common/workOrderStatus.json';
import CommercialTable from './Common/ServiceToPerform/CommercialTable';
import StatusOutsideAlerter from "../../../Common/statusOutsideAlerter";
import ResidentialTable from './Common/ServiceToPerform/ResidentialTable';
import { DebounceInput } from 'react-debounce-input';
import { message, Checkbox } from 'antd';

import close from '../../../../Assets/images/close.png';
import chevronDown from '../../../../Assets/images/chevron-down.png';

// const { Option } = Select;
class Step2 extends Component {

  state = {
    current_tab: 1,
    intial_selected_row_keys: [],
    residential_selected_row_keys: [],
    commercial_selected_row_keys: [],
    // install_selected_row_keys: [],
    status: [],
    toggleStatusFilter: false,
    search_value: '',
    franchiseList: [],
    
    intial_allocated_service: [],
    residential_allocated_service: [],
    commercial_allocated_service: [],
    // install_allocated_service: [],
    
    intial_staff_pagination: { showSizeChanger: false, pageSize: 15, ordering: "", current: 1 },
    residential_staff_pagination: { showSizeChanger: false, pageSize: 15, current: 1 },
    commercial_staff_pagination: { showSizeChanger: false, pageSize: 15, current: 1 },
    // install_staff_pagination: { showSizeChanger: false, pageSize: 15, current: 1 },

    activePagination: '15',
    intialActivePagination: '15',
    residentialActivePagination: '15',
    commercialActivePagination: '15',
    // installActivePagination: '15',

    // All selection
    is_all_selected_residential: false,
    is_all_selected_commercial: false,
    all: [],

    loader: false,
    schedule_start_time: '',
    schedule_end_time: ''
  }

  componentDidMount = () => {
    this.setState({ loader: true });

    // let { intial_staff_pagination, residential_staff_pagination, commercial_staff_pagination, install_staff_pagination, } = this.state;
    let { intial_staff_pagination, residential_staff_pagination, commercial_staff_pagination } = this.state;

    // const schedule_start_time = moment(`${this.props.weekStartDate}T00:00:00`).toISOString();
    // const schedule_end_time = moment(`${this.props.weekStartDate}T23:59:59`).add(6, 'days').toISOString();
    // const schedule_start_time = this.props.weekStartDate + 'T00:00:00';
    // const schedule_end_time = moment(this.props.weekStartDate).add(6, 'days').format('YYYY-MM-DD') + 'T23:59:00';
    
    const schedule_start_time = this.props.weekStartDate + 'T00:00:00';
    const schedule_end_time = moment(this.props.weekStartDate).add(6, 'days').format('YYYY-MM-DD') + 'T23:59:00';

    this.setState({
      schedule_start_time: schedule_start_time,
      schedule_end_time: schedule_end_time
    });

    //Intial Clean
    this.props.getServiceAllocationIntialClean({
      limit: 15,
      offset: (intial_staff_pagination.current * 15) - 15,
      service_skill_type__skill_name__in: 'residential_init_clean',
      scheduled_time__gte: schedule_start_time,
      scheduled_time__lte: schedule_end_time,
      // status: "tentative",
      ordering: 'service_order__user__first_name',
      service_order__field_office__uuid: this.props.selected_franchise
    });

    //Residential Clean
    this.props.getServiceAllocationResidentail({
      limit: 15,
      offset: (residential_staff_pagination.current * 15) - 15,
      service_skill_type__skill_name__in: 'residential_regular',
      scheduled_time__gte: schedule_start_time,
      scheduled_time__lte: schedule_end_time,
      // status: "tentative",
      ordering: 'service_order__user__first_name',
      service_order__field_office__uuid: this.props.selected_franchise
    });

    //Commercial
    this.props.getServiceAllocationCommercail({
      limit: 15,
      offset: (commercial_staff_pagination.current * 15) - 15,
      service_skill_type__skill_name__in: 'common_area_cleaning,pet_waste_station,installation_repair,pet_waste_station_install',
      scheduled_time__gte: schedule_start_time,
      scheduled_time__lte: schedule_end_time,
      // status: "tentative",
      ordering: 'service_order__user__first_name',
      service_order__field_office__uuid: this.props.selected_franchise
    });

    //Install
    // this.props.getServiceAllocationInstall({
    //   limit: 15,
    //   offset: (install_staff_pagination.current * 15) - 15,
    //   service_skill_type__skill_name__in: 'pet_waste_station_install',
    //   scheduled_time__gte: schedule_start_time,
    //   scheduled_time__lte: schedule_end_time,
    //   // status: "tentative",
    //   ordering: 'scheduled_time',
    //   service_order__field_office__uuid: this.props.selected_franchise
    // })
  }

  UNSAFE_componentWillReceiveProps = (props) => {
    let {
      intial_staff_pagination,
      residential_staff_pagination,
      commercial_staff_pagination,
      residential_selected_row_keys,
      commercial_selected_row_keys,
      is_all_selected_residential,
      is_all_selected_commercial,
      all
    } = this.state;

    //get Intial Service
    if (Object.keys(props.IntialService.data).length > 0 && props.IntialService.data !== this.props.IntialService.data) {

      intial_staff_pagination.total = props.IntialService.data.count;
      let data = props?.IntialService?.data?.results.filter(item => item.is_selected === true).map(item => item.uuid);
      sessionStorage.setItem('already_scheduled_intial_selected_row_keys', JSON.stringify(data));
      this.setState({
        loader: false,
        intial_staff_pagination,
        intial_allocated_service: props.IntialService.data.results,
        intial_selected_row_keys: JSON.parse(sessionStorage.getItem('intial_selected_row_keys')) || [],
      })
    }

    if (Object.keys(props.IntialService.errors).length > 0 && props.IntialService.errors !== this.props.IntialService.errors) {
      this.setState({
        loader: false,
      });
      errorHandle(props?.IntialService?.errors);
    }

    //get Residential Service
    if (Object.keys(props.ResidentailService.data).length > 0 && props.ResidentailService.data !== this.props.ResidentailService.data) {
      residential_staff_pagination.total = props.ResidentailService.data.count;
      if(is_all_selected_residential && residential_selected_row_keys.length === 0)
      {
        let keys = props?.ResidentailService?.data.results.map(row => row.uuid);
        sessionStorage.setItem('residential_selected_row_keys', JSON.stringify(keys));
        
        this.setState({
          loader: false,
          all: keys.length,
          residential_staff_pagination,
          residential_selected_row_keys: keys
        });
      }
      else
      {
        let residential_selected_row_keys = JSON.parse(sessionStorage.getItem('residential_selected_row_keys')) || [];
        let data = props?.ResidentailService?.data?.results.filter(item => item.is_selected === true).map(item => item.uuid);
        sessionStorage.setItem('already_scheduled_residential_selected_row_keys', JSON.stringify(data));
        this.setState({
          loader: false,
          residential_staff_pagination,
          residential_selected_row_keys,
          residential_allocated_service: props.ResidentailService.data.results
        });
      }
    }

    if (Object.keys(props.ResidentailService.errors).length > 0 && props.ResidentailService.errors !== this.props.ResidentailService.errors) {
      this.setState({
        loader: false,
      });
      errorHandle(props?.ResidentialService?.errors);
    }

    //get Commercial Service
    if (Object.keys(props.CommercialService.data).length > 0 && props.CommercialService.data !== this.props.CommercialService.data) {
      commercial_staff_pagination.total = props.CommercialService.data.count;
      if(is_all_selected_commercial && commercial_selected_row_keys.length === 0)
      {
        let keys = props?.CommercialService?.data.results.map(row => row.uuid);
        sessionStorage.setItem('commercial_selected_row_keys', JSON.stringify(keys));
        
        this.setState({
          loader: false,
          all: keys.length,
          commercial_staff_pagination,
          commercial_selected_row_keys: keys
        });
      }
      else
      {
        let data = props?.CommercialService?.data?.results.filter(item => item.is_selected === true).map(item => item.uuid);
        sessionStorage.setItem('already_scheduled_commercial_selected_row_keys', JSON.stringify(data));
        this.setState({
          loader: false,
          commercial_staff_pagination,
          commercial_allocated_service: props.CommercialService.data.results,
          commercial_selected_row_keys: JSON.parse(sessionStorage.getItem('commercial_selected_row_keys')) || []
        });
      }
    }

    if (Object.keys(props.CommercialService.errors).length > 0 && props.CommercialService.errors !== this.props.CommercialService.errors) {
      this.setState({
        loader: false,
      });
      errorHandle(props?.CommercialService?.errors);
    }

    //get Install Service
    // if (Object.keys(props.InstallService.data).length > 0 && props.InstallService.data !== this.props.InstallService.data) {
    //   install_staff_pagination.total = props.InstallService.data.count;
    //   let data = props?.InstallService?.data?.results.filter(item => item.is_selected === true).map(item => item.uuid);
    //   sessionStorage.setItem('already_scheduled_install_selected_row_keys', JSON.stringify(data));
    //   this.setState({
    //     loader: false,
    //     install_staff_pagination,
    //     install_allocated_service: props.InstallService.data.results,
    //     install_selected_row_keys: JSON.parse(sessionStorage.getItem('install_selected_row_keys')) || []
    //   })
    // }

    // if (Object.keys(props.InstallService.errors).length > 0 && props.InstallService.errors !== this.props.InstallService.errors) {
    //   this.setState({
    //     loader: false,
    //   });
    //   errorHandle(props?.InstallService?.errors);
    // }
  }

  // Intial Table  Pagination
  intialPaginationChange = (pagination, filters, sorter) => {
    let { intial_staff_pagination } = this.state;
    intial_staff_pagination = pagination ? Object.assign(intial_staff_pagination, { 'current': pagination?.current }) : intial_staff_pagination ;

    let ordering;

    if (sorter?.column) {
      ordering = sorter?.order === 'ascend' ? `-${sorter?.columnKey}` : `${sorter?.columnKey}`
    }
    
    let q;
    if (this.state.search_value) {
      q = this.state.search_value;
    }
    let status__in;
    if(this.state.status && this.state.status.length > 0){
      status__in = this.state.status.toString();
    }

    const offset = pagination ? (pagination.current - 1) * pagination.pageSize : (intial_staff_pagination.current - 1) * intial_staff_pagination.pageSize;
    const limit = pagination ? pagination.pageSize : intial_staff_pagination.pageSize;

    this.props.getServiceAllocationIntialClean({
      limit: limit,
      offset: offset,
      service_skill_type__skill_name__in: 'residential_init_clean',
      scheduled_time__gte: this.state.schedule_start_time,
      scheduled_time__lte: this.state.schedule_end_time,
      // status: "tentative",
      ordering,
      q,
      status__in,
      service_order__field_office__uuid: this.props.selected_franchise
    });

    this.setState({
      loader: true,
      intial_staff_pagination
    })
  }

  //Residential Table  Pagination
  residentialPaginationChange = (pagination, filters, sorter) => {
    let { residential_staff_pagination } = this.state;
    residential_staff_pagination = pagination ?  Object.assign(residential_staff_pagination, { 'current': pagination?.current }): residential_staff_pagination;

    let ordering = 'service_order__user__first_name';

    if (sorter?.column) {
      ordering += sorter?.order === 'ascend' ? `-${sorter?.columnKey}` : `${sorter?.columnKey}`
    }
   
    let q;
    if (this.state.search_value) {
      q = this.state.search_value;
    } 

    let status__in;
    if(this.state.status && this.state.status.length > 0){
      status__in = this.state.status.toString();
    }

    const offset = pagination ? (pagination.current - 1) * pagination.pageSize : (residential_staff_pagination.current - 1) * residential_staff_pagination.pageSize;
    const limit = pagination ? pagination.pageSize : residential_staff_pagination.pageSize;

    this.props.getServiceAllocationResidentail({
      limit: limit,
      offset: offset,
      service_skill_type__skill_name__in: 'residential_regular',
      scheduled_time__gte: this.state.schedule_start_time,
      scheduled_time__lte: this.state.schedule_end_time,
      // status: "tentative",
      ordering,
      q,
      status__in,
      service_order__field_office__uuid: this.props.selected_franchise
    });

    this.setState({
      loader: true,
      residential_staff_pagination
    })
  }

  //Residential Table  Pagination
  commercialPaginationChange = (pagination, filters, sorter) => {
    let ordering;
    let { commercial_staff_pagination } = this.state;
    commercial_staff_pagination = pagination ?  Object.assign(commercial_staff_pagination, { 'current': pagination?.current }) : commercial_staff_pagination ;

    if (sorter?.column) {
      ordering = sorter?.order === 'ascend' ? `-${sorter?.columnKey}` : `${sorter?.columnKey}`;
    }
    
    let q;
    if (this.state.search_value) {
      q = this.state.search_value;
    }

    let status__in;
    if(this.state.status && this.state.status.length > 0) {
      status__in = this.state.status.toString();
    }

    const offset = pagination ? (pagination.current - 1) * pagination.pageSize : (commercial_staff_pagination.current - 1) * commercial_staff_pagination.pageSize;
    const limit = pagination ? pagination.pageSize : commercial_staff_pagination.pageSize;

    this.props.getServiceAllocationCommercail({
      limit: limit,
      offset: offset,
      service_skill_type__skill_name__in: 'common_area_cleaning,pet_waste_station,pet_waste_station_install',
      scheduled_time__gte: this.state.schedule_start_time,
      scheduled_time__lte: this.state.schedule_end_time,
      // status: "tentative",
      ordering,
      q,
      status__in,
      service_order__field_office__uuid: this.props.selected_franchise
    });
    this.setState({
      loader: true,
      commercial_staff_pagination
    })
  }

  // Install Table  Pagination
  // installPaginationChange = (pagination, filters, sorter) => {
  //   let { install_staff_pagination } = this.state;
  //   install_staff_pagination = Object.assign(install_staff_pagination, { 'current': pagination.current });

  //   let ordering = '';

  //   if (sorter.column) {
  //     ordering = sorter.order === 'ascend' ? `-${sorter.columnKey}` : `${sorter.columnKey}`
  //   }
  //   else {
  //     ordering = ''
  //   }
  //   const offset = (pagination.current - 1) * pagination.pageSize;
  //   const limit = pagination.pageSize;

  //   this.props.getServiceAllocationInstall({
  //     limit: limit,
  //     offset: offset,
  //     service_skill_type__skill_name__in: 'pet_waste_station_install',
  //     scheduled_time__gte: this.state.schedule_start_time,
  //     scheduled_time__lte: this.state.schedule_end_time,
  //     status: "tentative",
  //     ordering,
  //     service_order__field_office__uuid: this.props.selected_franchise
  //   });
  //   this.setState({
  //     loader: true,
  //     install_staff_pagination
  //   })
  // }

  //Select Intial User
  onIntialSelectedRowKeysChange = (intial_selected_row_keys) => {
    this.setState({ intial_selected_row_keys });
    sessionStorage.setItem('intial_selected_row_keys', JSON.stringify(intial_selected_row_keys));
  }

  //Testing
  onResidentialSelectedRowKeysChange = (residential_selected_row_keys) => {
    this.setState({ residential_selected_row_keys });
    sessionStorage.setItem('residential_selected_row_keys', JSON.stringify(residential_selected_row_keys));
  }

  //Select Commercial User
  onCommercialSelectedRowKeysChange = (commercial_selected_row_keys) => {
    this.setState({ commercial_selected_row_keys });
    sessionStorage.setItem('commercial_selected_row_keys', JSON.stringify(commercial_selected_row_keys));
  }

  //Change Tab
  ChangeTab = (tabValue) => {
    if (tabValue === 1){ 
      sessionStorage.setItem('intial_selected_row_keys', JSON.stringify([]));
      this.setState({intial_selected_row_keys:[]})
      this.setState({ activePagination: this.state.intialActivePagination, all: 0 });
    } 
    else if (tabValue === 2){
      sessionStorage.setItem('residential_selected_row_keys', JSON.stringify([]));
      this.setState({residential_selected_row_keys:[],is_all_selected_residential:false})
      this.setState({ activePagination: this.state.residentialActivePagination, all: 0 });
    }
    else if (tabValue === 3){
      sessionStorage.setItem('commercial_selected_row_keys', JSON.stringify([]));
      this.setState({commercial_selected_row_keys:[],is_all_selected_commercial:false})
      this.setState({ activePagination: this.state.commercialActivePagination, all: 0 });
    }
    // else if (tabValue === 4) { this.setState({ activePagination: this.state.installActivePagination }) }

    this.setState({ current_tab: tabValue });
  }

  onFilterChange = () => {
    // const { customerId } = this.props;
    // const { scheduled_time__range, service_order__uuid, work_order_number, technician__uuid, status, ordering, scheduled_time__gte, scheduled_time__lt, isServiceDetail, selectedService } = this.state;
    // const queryParams = {
    //   service_order__user__uuid:`${customerId}`,
    //   scheduled_time__range: `${scheduled_time__range}`,
    //   service_order__uuid__in: service_order__uuid && service_order__uuid.length > 0 ? `${service_order__uuid.join()}` : null,
    //   work_order_number__in: work_order_number && work_order_number.length > 0 ? `${work_order_number}` : null,
    //   technician__uuid__in: technician__uuid && technician__uuid.length > 0 ? `${technician__uuid.join()}` : null,
    //   status__in: status && status.length > 0 ? `${status.join()}` : null,
    //   ordering: `${ordering}`,
    //   scheduled_time__gte: `${scheduled_time__gte}`,
    //   scheduled_time__lt: `${scheduled_time__lt}`
    // }
    // if (isServiceDetail) {
    //   delete queryParams.service_order__uuid__in;
    //   queryParams['service_order__uuid'] = selectedService?.uuid;
    // } else {
    //   delete queryParams.service_order__uuid;
    // }
    // const params = this.filterParams(queryParams);
    // this.props.getWorkOrderList(params);
    // if (scheduled_time__lt) {
    //   this.props.getWorkOrderFilter({service_order__user__uuid: customerId, scheduled_time__lt: `${scheduled_time__lt}`});
    // }
  }

  toggleStatus = () => {
    const { toggleStatusFilter } = this.state;
    if (toggleStatusFilter) {
      this.setState({ toggleStatusFilter: false });
    } else {
      this.setState({ toggleStatusFilter: true, });
    }
  }

  clearStatus = () => {
    workOrderStatus.WorkOrderStatus.forEach(element => {
      element['is_change'] = false;
    });
    this.setState({ status: [], toggleStatusFilter: false }, () => {
      this.onFilterChange();
      if(this.state.current_tab === 1){
        this.intialPaginationChange();
      }
      else if(this.state.current_tab === 2){
        this.residentialPaginationChange();
      }
      else if(this.state.current_tab === 3){
        this.commercialPaginationChange();
      }
    });
  }

  clearServiceOrder = () => {
    const { serviceOrderFilter } = this.state;
    if (document.getElementById("allServiceOrder")) {
      document.getElementById("allServiceOrder").checked = false
    }
    serviceOrderFilter.forEach(element => {
      element['is_change'] = false;
    });
    this.setState({ service_order__uuid: [], toggleServiceOrderFilter: false, allServiceOrderSelected: false }, () => {
      this.onFilterChange();
    });
  }

  closeStatusFilter = () => {
    this.setState({ toggleStatusFilter: false });
  }
  onStatusChanged = (e, index) => {
    const { status} = this.state;
    let arrStatus = [...status];
    if (e.target.checked) {
      if (index === 0) {
        workOrderStatus.WorkOrderStatus.forEach((element, index) => {
          element['is_change'] = true;
          if (index > 0 && arrStatus.indexOf(element.value) === -1) {
            arrStatus.push(element.value)
          }
        });
      } else {
        if (arrStatus.indexOf(e.target.id) === -1) {
          workOrderStatus.WorkOrderStatus[index]['is_change'] = true;
          arrStatus.push(e.target.id)
        }
      }
    } else {
      if (index === 0) {
        workOrderStatus.WorkOrderStatus.forEach(element => {
          element['is_change'] = false;
        });
        arrStatus = []
      } else {
        const ind = arrStatus.indexOf(e.target.id);
        if (ind > -1) {
          workOrderStatus.WorkOrderStatus[0]['is_change'] = false;
          workOrderStatus.WorkOrderStatus[index]['is_change'] = false;
          arrStatus.splice(ind, 1);
        }
      }
    }
    this.setState({ status: arrStatus }, () => {
      if(this.state.current_tab === 1){
        this.intialPaginationChange();
      }
      else if(this.state.current_tab === 2){
        this.residentialPaginationChange();
      }
      else if(this.state.current_tab === 3){
        this.commercialPaginationChange();
      }
    });
  }

  //#region "Status Filter"
  renderStatusFilters = () => {
    const { toggleStatusFilter, status } = this.state;
    return (
      <StatusOutsideAlerter
        closeStatusFilter={this.closeStatusFilter}
      >
        <div className="form-group image-input stat-input border-color background-color">
          <div className="fitem mb-0">
            {/* <input type="text" readOnly id="txtStatus" placeholder={status && status.length === 0 ? 'Status: All' : `Status: ${status}`} onFocus={() => { this.toggleStatus() }} /> */}
            <div className="selected-drop-down-value fs-14" onClick={() => { this.toggleStatus() }}>
              {status && status.length === 0 && <div className=""><strong>Status: </strong> All</div>}
              {status && status.length > 0 && <div className="flex justify-content-start"> <strong>Status: </strong><div className="selected-value-filter">{`${status}`}</div> </div> }
            </div> 

            {status && status.length === 0 &&
              <img className="cursor-pointer" src={chevronDown} alt="" onClick={() => { this.toggleStatus() }} />
            }
            {status && status.length > 0 &&
              <img src={close} alt="" onClick={() => { this.clearStatus() }} />
            }
          </div>
          {toggleStatusFilter && <div className="field-dropdown  custom-width">
            <div className="field-dropdown-body custom-height-optimo-routing">
              {map(workOrderStatus.WorkOrderStatus, (item, index) => {
                if(item.value !== 'complete' && item.value !== 'incomplete' && item.value !== 'cancelled_non_billable' && item.value !== 'cancelled_billable' )
                  return (
                    <div key={index} className="fitem-check">
                      <input id={item.value} type="checkbox" className="fitem-ck-input" onChange={(e) => { this.onStatusChanged(e, index) }} checked={item.is_change} />
                      <label htmlFor={item.value} className="fitem-ck-txt">{item.label}</label>
                    </div>
                  )
              })}
            </div>
          </div>}
        </div>
      </StatusOutsideAlerter>
    )
  }

  renderHeaderCheckbox = (all_selected, table) => {
    return <Checkbox
      checked={all_selected}
      onChange={() => this.handleSelectAll(table)}
    />
  }

  handleSelectAll = (currentTable) => {
    const {
      schedule_end_time,
      schedule_start_time,
      is_all_selected_commercial,
      is_all_selected_residential,
    } = this.state;

    switch(currentTable)
    {
    case "residential":
      if(!is_all_selected_residential)
      {
        this.setState({
          loader: true,
          is_all_selected_residential: true,
          residential_selected_row_keys: []
        });

        this.props.getServiceAllocationResidentail({
          offset: 0,
          limit: 5000,
          service_skill_type__skill_name__in: 'residential_regular',
          scheduled_time__gte: schedule_start_time,
          scheduled_time__lte: schedule_end_time,
          ordering: 'service_order__user__first_name',
          service_order__field_office__uuid: this.props.selected_franchise
        });
      }
      else
      {
        sessionStorage.setItem('residential_selected_row_keys', JSON.stringify([]));

        this.setState({
          all: 0,
          is_all_selected_residential: false,
          residential_selected_row_keys: []
        });

      }
      break;
    case "commercial":
      if(!is_all_selected_commercial)
      {
        this.setState({
          loader: true,
          is_all_selected_commercial: true,
          commercial_selected_row_keys: []
        });

        this.props.getServiceAllocationCommercail({
          offset: 0,
          limit: 5000,
          service_skill_type__skill_name__in: 'common_area_cleaning,pet_waste_station,installation_repair,pet_waste_station_install',
          scheduled_time__gte: schedule_start_time,
          scheduled_time__lte: schedule_end_time,
          ordering: 'service_order__user__first_name',
          service_order__field_office__uuid: this.props.selected_franchise
        });
      }
      else
      {
        sessionStorage.setItem('commercial_selected_row_keys', JSON.stringify([]));

        this.setState({
          all: 0,
          is_all_selected_commercial: false,
          commercial_selected_row_keys: []
        });
      }
      break;
    }
  };

  renderTable = () => {
    let {
      current_tab,
      is_all_selected_commercial,
      is_all_selected_residential,

      //Selected Key
      intial_selected_row_keys,
      residential_selected_row_keys,
      commercial_selected_row_keys,

      //Pagination
      intial_staff_pagination,
      residential_staff_pagination,
      commercial_staff_pagination,

      //Datasource
      intial_allocated_service,
      residential_allocated_service,
      commercial_allocated_service
    } = this.state;

    if (current_tab === 1) {
      return (
        <IntialTable
          intial_selected_row_keys={intial_selected_row_keys}
          intial_staff_pagination={intial_staff_pagination}
          intial_allocated_service={intial_allocated_service}
          intialPaginationChange={this.intialPaginationChange}
          onIntialSelectedRowKeysChange={this.onIntialSelectedRowKeysChange}
          intial_staff_page_size_limit={this.renderPagination()}
        />
      )
    }

    else if (current_tab === 2) {
      return (
        <ResidentialTable
          residential_staff_pagination={residential_staff_pagination}
          residential_selected_row_keys={residential_selected_row_keys}
          residential_allocated_service={residential_allocated_service}

          handleSelectAll={this.handleSelectAll}
          residential_page_size_limit={this.renderPagination()}
          intialPaginationChange={this.residentialPaginationChange}
          onResidentialSelectedRowKeysChange={this.onResidentialSelectedRowKeysChange}
          renderHeaderCheckbox={() => this.renderHeaderCheckbox(is_all_selected_residential, "residential")}
        />
      )
    }
    else if (current_tab === 3) {
      return (
        <CommercialTable
          commercial_selected_row_keys={commercial_selected_row_keys}
          commercial_staff_pagination={commercial_staff_pagination}
          commercial_allocated_service={commercial_allocated_service}

          handleSelectAll={this.handleSelectAll}
          commercialPaginationChange={this.commercialPaginationChange}
          commercial_staff_page_size_limit={this.renderPagination()}
          onCommercialSelectedRowKeysChange={this.onCommercialSelectedRowKeysChange}
          renderHeaderCheckbox={() => this.renderHeaderCheckbox(is_all_selected_commercial, "commercial")}
        />
      )
    }
    // else if (current_tab === 4) {
    //   return (
    //     <InstallTable
    //       install_selected_row_keys={install_selected_row_keys}
    //       install_staff_pagination={install_staff_pagination}
    //       install_allocated_service={install_allocated_service}
    //       installPaginationChange={this.installPaginationChange}
    //       onInstallSelectedRowKeysChange={this.onInstallSelectedRowKeysChange}
    //       install_staff_page_size_limit={this.renderPagination()}
    //     />
    //   )
    // }
  }
  // page size change
  setStaffPageLimit = (value) => {
    const { intial_staff_pagination, residential_staff_pagination, commercial_staff_pagination, current_tab } = this.state;

    if (current_tab === 1) {
      this.setState({ loader: true });
      Object.assign(intial_staff_pagination, { current: 1, pageSize: value, ordering: '' });
      this.setState({ activePagination: value, intial_staff_pagination, intialActivePagination: value });
      this.props.getServiceAllocationIntialClean({
        limit: value,
        offset: (intial_staff_pagination.current * 15) - 15,
        service_skill_type__skill_name__in: 'residential_init_clean',
        scheduled_time__gte: this.state.schedule_start_time,
        scheduled_time__lte: this.state.schedule_end_time,
        // status: "tentative",
        ordering: 'service_order__user__first_name',
        service_order__field_office__uuid: this.props.selected_franchise
      })
    }
    else if (current_tab === 2) {
      this.setState({ loader: true });
      Object.assign(residential_staff_pagination, { current: 1, pageSize: value, ordering: '' });
      this.setState({ activePagination: value, residential_staff_pagination, residentialActivePagination: value });
      this.props.getServiceAllocationResidentail({
        limit: value,
        offset: (residential_staff_pagination.current * 15) - 15,
        service_skill_type__skill_name__in: 'residential_regular',
        scheduled_time__gte: this.state.schedule_start_time,
        scheduled_time__lte: this.state.schedule_end_time,
        // status: "tentative",
        ordering: 'service_order__user__first_name',
        service_order__field_office__uuid: this.props.selected_franchise
      })
    }
    else if (current_tab === 3) {
      this.setState({ loader: true });
      Object.assign(commercial_staff_pagination, { current: 1, pageSize: value, ordering: '' });
      this.setState({ activePagination: value, commercial_staff_pagination, commercialActivePagination: value });
      this.props.getServiceAllocationCommercail({
        limit: value,
        offset: (commercial_staff_pagination.current * 15) - 15,
        service_skill_type__skill_name__in: 'common_area_cleaning,pet_waste_station,installation_repair,pet_waste_station_install',
        scheduled_time__gte: this.state.schedule_start_time,
        scheduled_time__lte: this.state.schedule_end_time,
        // status: "tentative",
        ordering: 'service_order__user__first_name',
        service_order__field_office__uuid: this.props.selected_franchise
      })
    }
    // else if (current_tab === 4) {
    //   this.setState({ loader: true });
    //   Object.assign(install_staff_pagination, { current: 1, pageSize: value, ordering: '' });
    //   this.setState({ activePagination: value, install_staff_pagination, installActivePagination: value });
    //   this.props.getServiceAllocationInstall({
    //     limit: value,
    //     offset: (install_staff_pagination.current * 15) - 15,
    //     service_skill_type__skill_name__in: 'pet_waste_station_install',
    //     scheduled_time__gte: this.state.schedule_start_time,
    //     scheduled_time__lte: this.state.schedule_end_time,
    //     // status: "tentative",
    //     ordering: 'scheduled_time',
    //     service_order__field_office__uuid: this.props.selected_franchise
    //   })
    // }
  };

  renderPagination = () => {
    let { activePagination } = this.state;
    return <><ul className="pagination_page_size">
      <li>
        <span>Show:</span>
      </li>
      <li>
        <span
          onClick={() => { this.setStaffPageLimit('15') }}
          className={activePagination === '15' ? 'active' : ''}
        >15</span>
      </li>
      <li>
        <span
          className={activePagination === '30' ? 'active' : ''}
          onClick={() => { this.setStaffPageLimit('30') }}
        > 30</span>
      </li>
      <li>
        <span
          className={activePagination === '60' ? 'active' : ''}
          onClick={() => { this.setStaffPageLimit('60') }}
        >60</span>
      </li>
    </ul>
    </>
  }

  validateSelectedRowKeys = () => {
    if (this.state.intial_selected_row_keys.length || this.state.residential_selected_row_keys.length || this.state.commercial_selected_row_keys.length) {
      this.setState({
        all: 0,
        is_all_selected_commercial: false,
        is_all_selected_residential: false,
        commercial_selected_row_keys: [],
        residential_selected_row_keys: [],
      });

      this.props.nextStep(this.props.current === 0 ? 1 : this.props.current === 1 ? 2 : 0);
    }
    else{
      message.error('You must select at least one service.', 10);
    }
  }

  render() {
    let { current_tab, loader, search_value, franchiseList } = this.state;
    // let { current } = this.props;

    return (
      <div className="main">
        <div className="filter_wrapper acc-wrap flex no-background p-0">
          <div className="left_side mr-2 d-block">
            <h6 className="mb-5">Step 2 of 2: Select Services</h6>
            <h3>OptimoRoute Scheduling</h3>
          </div>

          <div className="right_side">
            <div className="form-group flex ai-center w-100 flex-end">
              <div className="fitem fitem-rinner licon custom-input">
                <div className="fitem-ricon">
                  <i className="las la-search"></i>
                </div>
                <DebounceInput
                  className="form-control"
                  placeholder="Search Requests"
                  minLength={3}
                  debounceTimeout={1000}
                  onChange={event => {
                    this.setState({ search_value: event.target.value });
                    if (current_tab === 1) {
                      this.intialPaginationChange()
                    }
                    else if (current_tab === 2) {
                      this.residentialPaginationChange()
                    }
                    else if (current_tab === 3) {
                      this.commercialPaginationChange()
                    }
                  }}
                />
              </div>
              <div className="fitem custom-drop-down">
                {this.renderStatusFilters()}
              </div>
              <div className="fitem">
                <div className="justify-content-end">
                  {
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        this.validateSelectedRowKeys()
                      }}>
                      Send to OptimoRoute</button>}
                </div>
              </div>
            </div>
          </div>
        </div>

        <ul className="tabs">
          <li className={current_tab === 1 ? 'active ml-0' : 'ml-0'} onClick={() => this.ChangeTab(1, 'residential_init_clean')}>
            <span>INITIAL CLEANS</span>
          </li>
          <li className={current_tab === 2 ? 'active' : ''} onClick={() => this.ChangeTab(2, 'residential_regular')}>
            <span>RESIDENTIAL</span>
          </li>
          <li className={current_tab === 3 ? 'active' : ''} onClick={() => this.ChangeTab(3, 'common_area_cleaning,pet_waste_station')}>
            <span>COMMERCIAL</span>
          </li>
          {/* <li className={current_tab === 4 ? 'active' : ''} onClick={() => this.ChangeTab(4, 'pet_waste_station_install')}>
            <span>INSTALLS</span>
          </li> */}
        </ul>
        <div>
          {this.renderTable()}
        </div>
        {loader ? <Loader /> : ''}
      </div>
    );
  }
}

export default Step2;